


export const analysisConfig = {
    companyanalysis: {
        // Backend clarification: `rate_avg_fees_per_transaction` is now
        // fees-as-percent-of-requested-amount (a real fee rate). Renamed the
        // column label so ops don't read the old meaningless number.
        columns: ["Company", "Total Employees", "Total Registered Employees", "Rate Registered Employees",
                  "Total Active Employees", "Rate Active Employees from Registered", "Rate Active Employees from Total",
                  "Total Request Amounts", "Total Revenue from Fees", "Total Transactions", "Avg Fees per Transaction",
                  "Fee Rate"],
        xKey: "company",
        barKey: "total_transactions",
        chartType: "line",
        filters: [
            { name: "company", label: "Company", type: "select", options: [] },
        ],
        pathName: "Company Analysis",
    },
    userstats: {
        // Backend clamps decline deltas to 0 (only growth is exposed) —
        // renamed the *_change columns to "Growth" so ops don't expect signed
        // deltas the API will never return.
        columns: ["Period", "Total Users", "Total Users Growth", "Total Active Users",
                  "Active Users Growth Rate", "Monthly Active Users", "Monthly Active Users Growth Rate",
                  "Monthly Active Users Rate Total", "Monthly Active Users Rate Active"],
        xKey: "period",
        barKey: "total_users",
        chartType: "line",
        filters: [
            { name: "start_date", label: "Start Date", type: "date" },
            { name: "end_date", label: "End Date", type: "date" },
        ],
        pathName: "User Analysis",
    },
    revenueanalysis: {
        // Backend added total_net_revenue and avg_net_revenue_per_transaction;
        // and the three avg_*_per_transaction fields are now real money
        // (previously inverted into tiny numbers). TableComponent's money-key
        // list carries the formatting change.
        columns: [
            "Period",
            "Total Transactions",
            "Total Requested Amount",
            "Total Revenue from Fees",
            "Total Net Revenue",
            "Avg Requested Amount per Transaction",
            "Avg Fees per Transaction",
            "Avg Net Revenue per Transaction",
        ],
        xKey: "period",
        barKey: "total_transactions",
        chartType: "line",
        filters: [
            { name: "start_date", label: "Start Date", type: "date" },
            { name: "end_date", label: "End Date", type: "date" },
        ],
        pathName: "Revenue Analysis",
    },
    transactionanalysis: {
        // Super-admin only. Bands are chosen at query time — either explicit
        // ranges (repeatable ?ranges=a,b) or ?buckets=N. The `bands` filter
        // type is handled by FilterForm's dynamic bands control; it flattens
        // into the right query params before dispatch.
        columns: ["Period", "Ranges", "Total Transactions", "Total Amount"],
        xKey: "period",
        barKey: "total_transactions",
        chartType: "line",
        filters: [
            { name: "start_date", label: "Start Date", type: "date" },
            { name: "end_date", label: "End Date", type: "date" },
            { name: "bands", label: "Amount Bands", type: "bands" },
        ],
        pathName: "Transaction Analysis",
    },
    clientanalysis: {
        // Backend no longer caps at 10 rows — TableComponent already paginates
        // client-side, so we surface Leaves as a column now that it's usable.
        // is_active=false now genuinely narrows results (previously ignored).
        columns: ["Total Transaction", "Active Month", "Average Requests Per Month", "Start Date",
                  "Company Name", "Client Name", "Net Salary", "Payment", "Fees", "Total Payment", "Leaves"],
        xKey: "client_name",
        barKey: "total_transaction",
        chartType: null,
        filters: [
            { name: "company", label: "Company", type: "select", options: [] },
            { name: "is_active", label: "Is Active", type: "select", options: [{ value: "true", label: "Active only" }, { value: "false", label: "Inactive only" }] },
            { name: "has_made_withdraw", label: "Has Made Withdrawal", type: "select", options: [{ value: "true", label: "Yes" }, { value: "false", label: "No" }] },
            { name: "start_date", label: "Start Date", type: "date" },
            { name: "end_date", label: "End Date", type: "date" },
        ],
        pathName: "Client Analysis",
    },
    salaryrevenueanalysis: {
        // Backend fixed the monthly grouping — now one row per month (was
        // per-payment). Dropped the client-side dedupe/workaround that used
        // to live around the previous version of this table.
        columns: ["Period", "Total Salaries", "Total Active Salaries", "Total Request Amounts",
                  "Total Revenue from Fees", "Change In Total Revenue Rate", "Revenue Rate",
                  "Change In Revenue Rate", "Request Rate from Total Salaries", "Request Rate from Total Active Salaries"],
        xKey: "period",
        barKey: "total_salaries",
        chartType: "line",
        filters: [
            { name: "start_date", label: "Start Date", type: "date" },
            { name: "end_date", label: "End Date", type: "date" },
        ],
        pathName: "Salary Revenue Analysis",
    },
};